<img [ngClass]="{'no-active': !hasReceipt}" [src]="icon" style="width: 20px" alt="" />